/**
 * Call Data Field Constants
 * Centralized field name dictionary for easy refactoring
 */

export const CALL_FIELDS = {
  // IDs
  TELEPHONY_SESSION_ID: 'telephonySessionId',
  SESSION_ID: 'sessionId',
  RECORDING_ID: 'recordingId',

  // Time
  CALL_START_TIME: 'callStartTime',
  CALL_START_TIME_DISPLAY: 'callStartTimeDisplay',
  CALL_DURATION: 'callDuration',
  CREATED_AT: 'createdAt',
  ANALYSIS_COMPLETED_AT: 'analysisCompletedAt',
  TTL: 'ttl',

  // Call Info
  CALL_DIRECTION: 'callDirection',
  CALL_TYPE: 'callType',
  CALL_ACTION: 'callAction',
  CALL_RESULT: 'callResult',
  CALL_STATE: 'call_state',

  // From/To
  FROM_NAME: 'fromName',
  FROM_PHONE: 'fromPhoneNumber',
  FROM_EXTENSION: 'fromExtensionId',
  TO_NAME: 'toName',
  TO_PHONE: 'toPhoneNumber',
  TO_LOCATION: 'toLocation',

  // People
  STAFF_NAME: 'staff_name',
  CUSTOMER_TYPE: 'customer_type',

  // Categories & Outcomes
  PRIMARY_CATEGORY: 'primary_category',
  PRIMARY_SUBCATEGORY: 'primary_subcategory',
  PRIMARY_OUTCOME: 'primary_outcome',
  SECONDARY_TOPICS: 'secondary_topics',

  // Follow-up
  FOLLOW_UP_NEEDED: 'follow_up_needed',
  FOLLOW_UP_REASONS: 'follow_up_reasons',

  // Business
  CREDIT_CARD_CAPTURED: 'credit_card_captured',
  REVENUE_PRIORITY: 'revenue_priority',

  // Content
  EXECUTIVE_SUMMARY: 'executive_summary',

  // Organization
  FRANCHISE: 'franchise',
  SITE_ID: 'siteId',
  ACCOUNT_ID: 'accountId',
  SERVER_ID: 'serverId',

  // S3 Paths
  S3_AUDIO_PATH: 's3AudioPath',
  S3_TRANSCRIPT_PATH: 's3TranscriptPath',
  S3_ANALYSIS_PATH: 's3AnalysisPath',
} as const;

// Type-safe accessor
export type CallFieldKey = keyof typeof CALL_FIELDS;
export type CallFieldValue = (typeof CALL_FIELDS)[CallFieldKey];

/**
 * Field Display Labels
 */
export const CALL_FIELD_LABELS: Record<CallFieldValue, string> = {
  telephonySessionId: 'Session ID',
  sessionId: 'Session',
  recordingId: 'Recording ID',
  callStartTime: 'Time',
  callStartTimeDisplay: 'Time',
  callDuration: 'Dur.',
  createdAt: 'Created',
  analysisCompletedAt: 'Analyzed',
  ttl: 'TTL',
  callDirection: 'Direction',
  callType: 'Type',
  callAction: 'Action',
  callResult: 'Result',
  call_state: 'State',
  fromName: 'From',
  fromPhoneNumber: 'From Phone',
  fromExtensionId: 'Extension',
  toName: 'To',
  toPhoneNumber: 'To Phone',
  toLocation: 'Location',
  staff_name: 'Staff',
  customer_type: 'Customer',
  primary_category: 'Category',
  primary_subcategory: 'Subcategory',
  primary_outcome: 'Outcome',
  secondary_topics: 'Topics',
  follow_up_needed: 'Follow-up',
  follow_up_reasons: 'Follow-up Reasons',
  credit_card_captured: 'Card',
  revenue_priority: 'Priority',
  executive_summary: 'Summary',
  franchise: 'Franchise',
  siteId: 'Site',
  accountId: 'Account',
  serverId: 'Server',
  s3AudioPath: 'Audio',
  s3TranscriptPath: 'Transcript',
  s3AnalysisPath: 'Analysis',
};
